import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: '登录',
    component: () => import('@/views/Login/Login.vue')
  },
  {
    path: '/HomePage',
    name: '首页',
    component: () => import('@/views/Index/Index.vue')
  },
  {
    path: '/PageTransition',
    name: 'PageTransition',
    component: () => import('@/views/PageTransition.vue'),
    children: [
      {
        path: '/GoodsFolder',
        name: '商品管理模块',
        component: () => import('@/views/GoodsFolder/Templent_Goods.vue'),
        children:[
          //实物商品自有商品路由
          {
            path: '/GoodsList',
            name: '商品列表',
            meta: {
              navType: 0,
              belong: '实物商品',
              keepAliv: true,
            },
            component: () => import('@/views/GoodsFolder/GoodsCommodity/GoodsList.vue')
          },
          {
            path: '/GoodsBasicInfo/:goodscode',
            name: '基本信息',
            meta: {
              navType: 0,
              belong: '实物商品',
              keepAliv: false,
            },
            component: () => import('@/views/GoodsFolder/GoodsCommodity/GoodsBasicInfo.vue')
          },
          {
            path: '/GoodsSpecifyMange/:goodscode',
            name: '规格管理',
            meta: {
              navType: 0,
              belong: '实物商品',
              keepAliv: false,
            },
            component: () => import('@/views/GoodsFolder/GoodsCommodity/GoodsSpecifyMange.vue')
          },
          {
            path: '/GoodsInventoryMange/:goodscode',
            name: '库存管理',
            meta: {
              navType: 0,
              belong: '实物商品',
              keepAliv: false,
            },
            component: () => import('@/views/GoodsFolder/GoodsCommodity/GoodsInventoryMange.vue')
          },
          //兑换礼品券路由
          {
            path: '/GoodsGiftList',
            name: '兑换礼品券',
            meta: {
              navType: 0,
              belong: '兑换礼品券',
              keepAliv: true,
            },
            component: () => import('@/views/GoodsFolder/GoodsGift/GoodsGiftList.vue')
          },
          {
            path: '/GoodsGiftBasicInfo/:goodscode',
            name: '兑换礼券基本信息',
            meta: {
              navType: 0,
              belong: '兑换礼品券',
              keepAliv: false,
            },
            component: () => import('@/views/GoodsFolder/GoodsGift/GoodsGiftBasicInfo.vue')
          },
          {
            path: '/GoodsGiftSpecifyMange/:goodscode',
            name: '兑换礼券规格管理',
            meta: {
              navType: 0,
              belong: '兑换礼品券',
              keepAliv: false,
            },
            component: () => import('@/views/GoodsFolder/GoodsGift/GoodsGiftSpecifyMange.vue')
          },
           //酒旅产品路由
           {
            path: '/TravelList',
            name: '酒旅产品',
            meta: {
              navType: 0,
              belong: '酒旅产品',
              keepAliv: true,
            },
            component: () => import('@/views/GoodsFolder/Travel/TravelList.vue')
          },
          {
            path: '/TravelBasicInfo/:goodscode',
            name: '酒旅产品基本信息',
            meta: {
              navType: 0,
              belong: '酒旅产品',
              keepAliv: false,
            },
            component: () => import('@/views/GoodsFolder/Travel/TravelBasicInfo.vue')
          },
          {
            path: '/TravelSpecifyMange/:goodscode',
            name: '酒旅产品规格管理',
            meta: {
              navType: 0,
              belong: '酒旅产品',
              keepAliv: false,
            },
            component: () => import('@/views/GoodsFolder/Travel/TravelSpecifyMange.vue')
          },
        ]
      },
      {
      path: '/CardSearchIndex',
      name: '券卡查询',
      meta: {
        navType: 1,
        belong: '券卡查询'
      },
      component: () => import('@/views/CardsFolder/CardsSearch/SearchIndex.vue')
    },
    {
      path: '/CodesCollection',
      name: '卡号采集',
      meta: {
        navType:1,
        belong: '卡号采集'
      },
      component: () => import('@/views/CardsFolder/CodesCollection.vue'),
    },
    {
      path: '/CardsOut',
      name: '定义激活',
      meta: {
        navType: 1,
        belong: '礼品券卡管理'
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardManage/CardsOut.vue'),
    },
    {
      path: '/CardsActivation',
      name: '券卡激活',
      meta: {
        navType: 1,
        belong: '礼品券卡管理'
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardManage/CardsActivation.vue'),
    },
    {
      path: '/CardsPause',
      name: '券卡暂停',
      meta: {
        navType: 1,
        belong: '礼品券卡管理'
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardManage/CardsPause.vue'),
    },
    {
      path: '/CardsReuse',
      name: '券卡恢复',
      meta: {
        navType: 1,
        belong: '礼品券卡管理'
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardManage/CardsReuse.vue'),
    },
    {
      path: '/CardsRecover',
      name: '券卡回收',
      meta: {
          navType: 1,
          belong: '礼品券卡管理',
          keepAliv: false,
      },
      component: () => import ('@/views/CardsFolder/CardsGift/CardManage/CardsRecover.vue'),
    },
    {
      path: '/CardMdShop',
      name: '门店铺券',
      meta: {
        navType: 1,
        belong: '礼品券卡管理'
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardManage/CardMdShop.vue'),
    },
    {
      path: '/OperateRecord',
      name: '出库记录',
      meta: {
        navType: 1,
        belong: '礼品券卡管理',
        keepAliv:true,
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardRecord/OperateRecord.vue'),
    },
    {
      path: '/CardsRecordOut/:num',
      name: '券卡记录出库',
      meta: {
        navType: 1,
        belong: '礼品券卡管理'
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardManage/CardsRecordOut.vue'),
    },
    {
      path: '/CardsEdit/:num',
      name: '券卡修改',
      meta: {
        navType: 1,
        belong: '礼品券卡管理'
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardManage/CardsEdit.vue'),
    },
    {
      path: '/CardRecordTotal',
      name: '礼品券卡操作记录总数',
      meta: {
        navType: 1,
        belong: '礼品券卡管理'
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardRecord/CardRecordTotal.vue'),
    },
    {
      path: '/ActivationRecord',
      name: '后续激活记录',
      meta: {
        navType: 1,
        belong: '礼品券卡管理',
        keepAliv:true,
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardRecord/ActivationRecord.vue'),
    },
    {
      path: '/ActivationRecordTotal',
      name: '后续激活记录操作记录总数',
      meta: {
        navType: 1,
        belong: '礼品券卡管理'
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardRecord/ActivationRecordTotal.vue'),
    },
    {
      path: '/PauseRecord',
      name: '暂停记录',
      meta: {
        navType: 1,
        belong: '礼品券卡管理',
        keepAliv:true,
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardRecord/PauseRecord.vue'),
    },
    {
      path: '/PauseRecordTotal',
      name: '暂停记录操作记录总数',
      meta: {
        navType: 1,
        belong: '礼品券卡管理'
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardRecord/PauseRecordTotal.vue'),
    },
    {
      path: '/ReuseRecord',
      name: '恢复记录',
      meta: {
        navType: 1,
        belong: '礼品券卡管理',
        keepAliv:true,
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardRecord/ReuseRecord.vue'),
    },
    {
      path: '/ReuseRecordTotal',
      name: '恢复记录操作记录总数',
      meta: {
        navType: 1,
        belong: '礼品券卡管理'
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardRecord/ReuseRecordTotal.vue'),
    },
    {
      path: '/SpreadRecordMd',
      name: '铺券记录',
      meta: {
        navType: 1,
        belong: '礼品券卡管理',
        keepAliv:true,
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardRecord/SpreadRecordMd.vue'),
    },
    {
      path: '/SpreadRecordMdTotal',
      name: '铺券记录总数',
      meta: {
        navType: 1,
        belong: '礼品券卡管理',
      },
      component: () => import('@/views/CardsFolder/CardsGift/CardRecord/SpreadRecordMdTotal.vue'),
    },
    {
        path: '/RecoverRecord',
        name: '券卡回收记录',
        meta: {
            navType: 1,
            belong: '礼品券卡管理',
            keepAliv: true,
        },
        component: () => import ('@/views/CardsFolder/CardsGift/CardRecord/RecoverRecord.vue'),
    },
    {
        path: '/RecoverRecordTotal',
        name: '券卡回收记录操作记录总数',
        meta: {
            navType: 1,
            belong: '礼品券卡管理',
            keepAliv: false,
        },
        component: () => import ('@/views/CardsFolder/CardsGift/CardRecord/RecoverRecordTotal.vue'),
    },
    {
      path: '/CardsElectron',
      name: '电子券管理模块',
      component: () => import('@/views/CardsFolder/CardsElectron/Templent_CardsElectron.vue'),
      children: [{
        path: '/CardsElectronOut',
        name: '电子券管理出库',
        meta: {
          navType: 1,
          belong: '电子券管理'
        },
        component: () => import('@/views/CardsFolder/CardsElectron/CardManage/CardsElectronOut.vue'),
      },
      {
        path: '/ElectronRecordOut',
        name: '电子券操作记录',
        meta: {
          navType: 1,
          belong: '电子券管理',
          keepAliv:true,
        },
        component: () => import('@/views/CardsFolder/CardsElectron/CardRecord/ElectronRecordOut.vue'),
      },
      {
        path: '/ElectronRecordOutTotal',
        name: '电子券管理操作记录总数',
        meta: {
          navType: 1,
          belong: '电子券管理'
        },
        component: () => import('@/views/CardsFolder/CardsElectron/CardRecord/ElectronRecordOutTotal.vue'),
      },
      {
        path: '/ElectronOperate/:num',
        name: '电子券操作记录操作',
        meta: {
          navType: 1,
          belong: '电子券管理'
        },
        component: () => import('@/views/CardsFolder/CardsElectron/CardManage/ElectronOperate.vue'),
      },
      ]
    },
    {
      path: '/OrderFolder',
      name: '订单管理模块',
      component: () => import('@/views/OrderFolder/Templent_Order.vue'),
      children: [
        {
          path: '/CardSearchIndexs',
          name: '券卡查询s',
          meta: {
            navType: 2,
            belong: '券卡查询s'
          },
          component: () => import('@/views/CardsFolder/CardsSearch/SearchIndex.vue')
        },
        //订单中心-门店销售
        {
          path: '/GoodsSale',
          name: '实物商品销售',
          meta: {
            navType: 2,
            belong: '门店销售',
          },
          component: () => import('@/views/OrderFolder/StoreSale/GoodsSale.vue'),
        },
        {
          path: '/CardSale',
          name: '券卡商品销售',
          meta: {
            navType: 2,
            belong: '门店销售',
          },
          component: () => import('@/views/OrderFolder/StoreSale/CardSale.vue'),
        },
        {
          path: '/SalesOrderManage',
          name: '销售单管理',
          meta: {
            navType: 2,
            belong: '门店销售',
            keepAliv: true,
          },
          component: () => import('@/views/OrderFolder/StoreSale/SalesOrderManage.vue'),
        },{
          path: '/SalesOrderDetail',
          name: '销售单详情',
          meta: {
            navType: 2,
            belong: '门店销售',
          },
          component: () => import('@/views/OrderFolder/StoreSale/SalesOrderDetail.vue'),
        },{
          path: '/HistoricalShipmentRecords',
          name: '历史发货记录',
          meta: {
            navType: 2,
            belong: '门店销售',
          },
          component: () => import('@/views/OrderFolder/StoreSale/HistoricalShipmentRecords.vue'),
        },{
          path: '/GoodSKUList',
          name: '商品SKU列表',
          meta: {
            navType: 2,
            belong: '门店销售',
          },
          component: () => import('@/views/OrderFolder/StoreSale/GoodSKUList.vue'),
        },
        {
          path: '/PayReceivedRecord',
          name: '收付款记录',
          meta: {
            navType: 2,
            belong: '门店销售',
          },
          component: () => import('@/views/OrderFolder/StoreSale/PayReceivedRecord.vue'),
        },{
          path: '/CardGather',
          name: '铺券汇总',
          meta: {
            navType:2,
            belong: '门店销售',
          },
          component: () => import('@/views/OrderFolder/StoreSale/CardGather.vue'),
        },
        {
          path: '/RefundManagement',
          name: '退款管理',
          meta: {
            navType: 2,
            belong: '门店销售',
          },
          component: () => import('@/views/OrderFolder/StoreSale/RefundManagement.vue'),
        },
        {
          path: '/GoodsSaleSubmit',
          name: '提交订单',
          meta: {
            navType: 2,
            belong: '门店销售',
          },
          component: () => import('@/views/OrderFolder/StoreSale/GoodsSaleSubmit.vue'),
        },
        {
          path: '/InvoiceApplyList',
          name: '会员申请开票列表',
          meta: {
            navType: 2,
            belong: '会员申请开票',
            keepAliv: true,
          },
          component: () => import('@/views/OrderFolder/InvoiceManage/InvoiceApplyList.vue'),
        },
        {
          path: '/InvoiceGoodsManages/:monye',
          name: '开票商品',
          meta: {
            navType: 2,
            belong: '会员申请开票',
          },
          component: () => import('@/views/InvoiceManage/InvoiceGoodsManage.vue'),
        },
        {
          path: '/InvoiceApply/:memberCode',
          name: '会员申请开票',
          meta: {
            navType: 2,
            belong: '会员申请开票',
          },
          component: () => import('@/views/OrderFolder/InvoiceManage/InvoiceApply.vue'),
        },
        {
          path: '/InvoiceApplyDetail/:recordcode/:operateType',
          name: '会员申请开票详情',
          meta: {
            navType: 2,
            belong: '会员申请开票',
          },
          component: () => import('@/views/OrderFolder/InvoiceManage/InvoiceApplyDetail.vue'),
        },
        {
          path: '/BuyerList',
          name: '购买方管理',
          meta: {
            navType: 2,
            belong: '会员申请开票',
          },
          component: () => import('@/views/OrderFolder/InvoiceManage/BuyerList.vue'),
        },
        {
          path: '/TelDelivery',
          name: '电话提货',
          meta: {
            navType: 2,
            belong: '电话提货',
          },
          component: () => import('@/views/OrderFolder/TelDelivery.vue'),
        },
        {
          path: '/Coupon',
          name: '优惠券提货',
          meta: {
            navType: 2,
            belong: '优惠券提货',
          },
          component: () => import('@/views/OrderFolder/Coupon.vue'),
        },
        {
          path: '/DoorDeliery',
          name: '到店自提',
          meta: {
            navType: 2,
            belong: '到店自提',
          },
          component: () => import('@/views/OrderFolder/DoorDeliery.vue'),
        },{
          path: '/MembersVisit',
          name: '会员上门',
          meta: {
            navType:2,
            belong: '会员上门',
          },
          component: () => import('@/views/OrderFolder/MembersVisit.vue'),
        },
        {
          path: '/cardDeliery',
          name: '卡包提货',
          meta: {
            navType: 2,
            belong: '卡包提货',
          },
          component: () => import('@/views/OrderFolder/cardDeliery.vue'),
        },
        {
          path: '/BulkVerification',
          name: '批量核销',
          meta: {
            navType: 2,
            belong: '批量核销',
          },
          component: () => import('@/views/OrderFolder/BulkVerification.vue'),
        },
        {
          path: '/AllOrder',
          name: '订单列表',
          meta: {
            navType: 2,
            belong: '全部订单',
          },
          component: () => import('@/views/OrderFolder/AllOrder.vue'),
        },
        ,{
          path: '/IntraCityDistributionOrder',
          name: '同城配送订单',
          meta: {
              navType: 2,
              belong: '全部订单',
              keepAliv: false,
          },
          component: () =>
              import ('@/views/OrderFolder/IntraCityDistributionOrder.vue'),
        },
        {
          path: '/OrdersProcessed',
          name: '总部派单记录',
          meta: {
            navType: 2,
            belong: '全部订单',
          },
          component: () => import('@/views/OrderFolder/OrdersProcessed.vue'),
        },
        {
          path: '/EjmdOrdersProcessed',
          name: '二级门店派单记录',
          meta: {
            navType: 2,
            belong: '全部订单',
          },
          component: () => import('@/views/OrderFolder/EjmdOrdersProcessed.vue'),
        },
      ]
    },
    {
      path: '/DeliveryFolder',
      name: '发货管理模块',
      component: () => import('@/views/DeliveryFolder/Templent_Delivery.vue'),
      children: [{
        path: '/ShippedOrderList',
        name: '待发货订单',
        meta: {
          navType: 3,
          belong: '待发货订单',
        },
        component: () => import('@/views/DeliveryFolder/ShippedOrderList.vue'),
      },
      {
        path: '/ShippedOrderList_SellerMemo',
        name: '待发货订单-首列卖家备注',
        meta: {
          navType: 3,
          belong: '待发货订单',
          keepAliv: false,
        },
        component: () => import('@/views/DeliveryFolder/ShippedOrderList_SellerMemo.vue'),
      },
      {
        path: '/ExpressPrintList',
        name: '快递打印列表',
        meta: {
          navType: 3,
          belong: '快递打印列表',
          keepAliv: true,
        },
        component: () => import('@/views/DeliveryFolder/ExpressPrintList.vue'),
      },
      {
        path: '/TypePrintingList/:printType',
        name: '针式热敏打印列表',
        meta: {
          navType: 3,
          belong: '快递打印列表'
        },
        component: () => import('@/views/DeliveryFolder/TypePrintingList.vue'),
      },
      {
        path: '/orderCollectionList/:nonOddCollection',
        name: '单号采集列表',
        meta: {
          navType: 3,
          belong: '快递打印列表'
        },
        component: () => import('@/views/DeliveryFolder/orderCollectionList.vue'),
      },{
        path: '/PrintListDetail/:expgenbatchno',
        name: '快递打印列表详情',
        meta: {
          navType: 3,
          belong: '快递打印列表'
        },
        component: () => import('@/views/DeliveryFolder/PrintListDetail.vue'),
      },
      {
        path: '/ExpressPrintRecord',
        name: '快递打印记录',
        meta: {
          navType: 3,
          belong: '快递打印记录',
          keepAliv: true,
        },
        component: () => import('@/views/DeliveryFolder/ExpressPrintRecord.vue'),
      },
      {
        path: '/PrintRecordDetail/:expgenbatchno',
        name: '快递打印记录详情',
        meta: {
          navType: 3,
          belong: '快递打印记录'
        },
        component: () => import('@/views/DeliveryFolder/PrintRecordDetail.vue'),
      },
      {
        path: '/PrintRecordBatchDetail/:expgenbatchno',
        name: '快递打印记录批次详情',
        meta: {
          navType: 3,
          belong: '快递打印记录'
        },
        component: () => import('@/views/DeliveryFolder/PrintRecordBatchDetail.vue'),
      },
      {
        path: '/AllExpressList',
        name: '全部快递',
        meta: {
          navType: 3,
          belong: '全部快递'
        },
        component: () => import('@/views/DeliveryFolder/AllExpress/AllExpressList.vue'),
      },
      {
        path: '/MissingExpressList',
        name: '快递漏单列表',
        meta: {
            navType: 3,
            belong: '快递漏单列表',
            keepAliv: true,
        },
        component: () => import ('@/views/DeliveryFolder/MissingExpressList.vue'),
     },
      {
        path: '/ERPDeliveryRecord',
        name: 'ERP发货记录',
        meta: {
          navType: 3,
          belong: 'ERP发货记录'
        },
        component: () => import('@/views/DeliveryFolder/ERPDeliveryRecord.vue'),
      },
      {
        path: '/orderPending',
        name: '发货_总部派单',
        meta: {
          navType: 3,
          belong: '总部派单记录',
        },
        component: () => import('@/views/DeliveryFolder/orderPending.vue'),
      },
      {
        path: '/refundVerifyList',
        name: '退款审核列表',
        meta: {
          navType: 3,
          belong: '退款审核列表',
        },
        component: () => import('@/views/DeliveryFolder/RefundVerifyList.vue'),
      },
      ]
    },
    {
      path: '/ManageFolder',
      name: '管理中心模块',
      component: () => import('@/views/ManageFolder/Templent_Manage.vue'),
      children: [{
        path: '/OrdConfiguration',
        name: '订单发货通知设置',
        meta: {
          navType: 6,
          belong: '订单发货通知设置',
        },
        component: () => import('@/views/ManageFolder/SysConfiguration/OrdConfiguration/OrdConfiguration.vue'),
      },{
        path: '/DlyConfiguration',
        name: '快递服务配置',
        meta: {
          navType: 6,
          belong: '快递服务配置',
        },
        component: () => import('@/views/ManageFolder/SysConfiguration/OrdConfiguration/DlyConfiguration.vue'),
      },
      {
        path: '/SenderInfo',
        name: '寄件方信息管理',
        meta: {
          navType: 6,
          belong: '寄件方信息管理',
        },
        component: () => import('@/views/ManageFolder/SysConfiguration/OrdConfiguration/SenderInfo.vue'),
      },
      {
        path: '/MemberList',
        name: '会员列表',
        meta: {
          navType: 6,
          belong: '会员列表',
          keepAliv: true,
        },
        component: () => import('@/views/ManageFolder/PlatformUser/MemberList.vue'),
      },
      {
        path: '/MemberDetail/:membercode',
        name: '会员详情',
        meta: {
            navType: 6,
            belong: '会员列表',
            keepAliv: false,
        },
        component: () => import ('@/views/ManageFolder/PlatformUser/MemberDetail.vue'),
      },
      {
        path: '/MySelfActivateRecord',
        name: '激活账户信息',
        meta: {
          navType:6,
          belong: '激活账户信息',
        },
        component: () => import('@/views/ManageFolder/PlatformUser/MySelfActivateRecord.vue'),
      },
      {
        path: '/SecondaryStores',
        name: '二级门店管理',
        meta: {
          navType: 6,
          belong: '二级门店管理',
        },
        component: () => import('@/views/ManageFolder/PlatformUser/SecondaryStores.vue'),
      },
      {
        path: '/CompanyStore',
        name: '微门店用户',
        meta: {
          navType: 6,
          belong: '微门店管理',
          keepAliv: true,
        },
        component: () => import('@/views/ManageFolder/PlatformUser/CompanyStore.vue'),
      },
      {
        path: '/CompanyStoreOperate/:operate',
        name: '微门店用户操作',
        meta: {
          navType: 6,
          belong: '微门店管理',
        },
        component: () => import('@/views/ManageFolder/PlatformUser/CompanyStoreOperate.vue'),
      },
      {
        path: '/CompanyActivationRecord',
        name: '激活记录',
        meta: {
          navType: 6,
          belong: '微门店管理',
        },
        component: () => import('@/views/ManageFolder/PlatformUser/CompanyActivationRecord.vue'),
      },
      {
        path: '/CompanyRecordTotal',
        name: '激活记录总数',
        meta: {
          navType: 6,
          belong: '微门店管理',
        },
        component: () => import('@/views/ManageFolder/PlatformUser/CompanyRecordTotal.vue'),
      },
      {
        path: '/WriteOffRecord',
        name: '核销记录',
        meta: {
          navType: 6,
          belong: '微门店管理',
        },
        component: () => import('@/views/ManageFolder/PlatformUser/WriteOffRecord.vue'),
      }
      ,{
        path: '/WShopStatistic',
        name: '微门店数据报表',
        meta: {
          navType:6,
          belong: '微门店管理',
          keepAliv: false,
        },
        component: () => import('@/views/ManageFolder/PlatformUser/WShopStatistic.vue'),
      },{
        path: '/SalesmanExamine',
        name: '销售员注册审核',
        meta: {
          navType:6,
          belong: '销售人员',
          keepAliv: false,
        },
        component: () => import('@/views/ManageFolder/PlatformUser/SalesmanExamine.vue'),
      },{
        path: '/SalesmanManage',
        name: '销售员账号',
        meta: {
          navType:6,
          belong: '销售人员',
          keepAliv: false,
        },
        component: () => import('@/views/ManageFolder/PlatformUser/SalesmanManage.vue'),
      },
      //平台用户-金世尊
      {
        path: '/StoreManageJsz/:sellType', //系统类型：0：总部；1：门店；2：分销商',
        name: '全国门店',
        meta: {
          navType: 6,
          belong: '分销商管理',
          navName2: '分销商管理'
        },
        component: () => import('@/views/ManageFolder/ManageJsz/StoreManageJsz.vue'),
      },
      {
        path: '/StoreManageOperate/:sellType/:operate/:flowcode',
        name: '全国门店管理操作金世尊',
        meta: {
          navType: 6,
          belong: '全国门店',
          navName2: '分销商管理'
        },
        component: () => import('@/views/ManageFolder/PlatformUser/StoreManageOperate.vue'),
      },
      {
        path: '/QuotaManageJsz/:sellType/:flowcode', //sysType-系统类型：0：总部；1：门店；2：分销商  sellType:销售类型：0：自己；2：存在二级分销商
        name: '额度管理金世尊',
        meta: {
          navType: 6,
          belong: '额度管理',
          navName1: '账户信息',
          navName2: '分销商管理'
        },
        component: () => import('@/views/ManageFolder/ManageJsz/QuotaManage.vue'),
      },{
        path: '/RepaymentManageJsz/:sellType/:flowcode', //sysType-系统类型：0：总部；1：门店；2：分销商  sellType:销售类型：0：自己；2：存在二级分销商
        name: '结算管理金世尊',
        meta: {
          navType: 6,
          belong: '结算管理',
          navName1: '账户信息',
          navName2: '分销商管理'
        },
        component: () => import('@/views/ManageFolder/ManageJsz/RepaymentManage.vue'),
      },{
        path: '/TransactionRecordJsz/:sellType/:flowcode', //sysType-系统类型：0：总部；1：门店；2：分销商  sellType:销售类型：0：自己；2：存在二级分销商
        name: '交易记录金世尊',
        meta: {
          navType: 6,
          belong: '交易记录',
          navName1: '账户信息',
          navName2: '分销商管理',
          keepAliv: true,
        },
        component: () => import('@/views/ManageFolder/ManageJsz/TransactionRecord.vue'),
      },{
        path: '/SalesOrderDetailMd',
        name: '账户销售单详情',
        meta: {
          navType: 6,
          belong: '交易记录',
          navName1: '账户信息',
          navName2: '分销商管理',
        },
        component: () => import('@/views/ManageFolder/ManageJsz/SalesOrderDetail.vue'),
      },
      {
        path: '/ShopSalesmandy',
        name: '店员管理1',
        meta: {
          navType: 6,
          belong: '店员管理',
          keepAliv: true,
        },
        component: () => import('@/views/ManageFolder/ManageJsz/ShopSalesmandy.vue'),
      },{
        path: '/ShopAddsalesmandy/:operate/:flowcode',
        name: '新增店员1',
        meta: {
          navType: 6,
          belong: '店员管理',
        },
        component: () => import('@/views/ManageFolder/ManageJsz/ShopAddsalesmandy.vue'),
      },
      {
        path: '/ShopSalesman',
        name: '店员管理',
        meta: {
          navType: 6,
          belong: '店员管理',
          keepAliv: true,
        },
        component: () => import('@/views/ManageFolder/ManageJsz/ShopSalesman.vue'),
      },{
        path: '/ShopAddsalesman/:operate/:flowcode',
        name: '新增店员',
        meta: {
          navType: 6,
          belong: '店员管理',
        },
        component: () => import('@/views/ManageFolder/ManageJsz/ShopAddsalesman.vue'),
      },{
        path: '/PaymentMange',
        name: '收付款账号',
        meta: {
          navType: 6,
          belong: '收付款账号',
        },
        component: () => import('@/views/ManageFolder/ManageJsz/PaymentMange.vue'),
      },{
        path: '/CodeScannerSetting',
        name: '扫码仪设置',
        meta: {
          navType: 6,
          belong: '扫码仪设置',
        },
        component: () => import('@/views/ManageFolder/CodeScannerSetting.vue'),
      },
      ]
    },
    // 数据统计路由
    {
      path: '/StatisticsFolder',
      name: '数据统计模块',
      component: () => import('@/views/StatisticsFolder/Templent_Statistics.vue'),
      children: [
        // 商品销售统计
        {
          path: '/CheckDeliveryedGoods',
          name: '发货商品盘点',
          meta: {
            navType: 8,
            belong: '发货商品盘点',
          },
          component: () => import('@/views/StatisticsFolder/CheckDeliveryedGoods.vue'),
        },
        {
        path: '/CardStatisticsList',
        name: '兑换礼券统计',
        meta: {
          navType: 8,
          belong: '券卡统计',
          keepAliv: true,
        },
        component: () => import('@/views/StatisticsFolder/CardStatistics/CardStatisticsList.vue'),
      },
      {
        path: '/CardBaseStatisticsList',
        name: '兑换礼券门店统计',
        meta: {
          navType: 8,
          belong: '券卡统计',
          keepAliv: true,
        },
        component: () => import('@/views/StatisticsFolder/CardStatistics/CardBaseStatisticsList.vue'),
      },
      {
        path: '/CardMemberStatisticsList',
        name: '兑换礼券会员统计',
        meta: {
          navType: 8,
          belong: '券卡统计',
          keepAliv: true,
        },
        component: () => import('@/views/StatisticsFolder/CardStatistics/CardMemberStatisticsList.vue'),
      },
      {
        path: '/SaleStaffStatisticsList',
        name: '按销售人员统计',
        meta: {
            navType: 8,
            belong: '券卡统计',
            keepAliv: true,
        },
        component: () =>import ('@/views/StatisticsFolder/CardStatistics/SaleStaffStatisticsList.vue'),
      },
      {
        path: '/CardErjiFlowStatisticsList',
        name: '兑换礼券二级门店统计',
        meta: {
            navType: 8,
            belong: '券卡统计',
            keepAliv: true,
        },
        component: () => import ('@/views/StatisticsFolder/CardStatistics/CardErjiFlowStatisticsList.vue'),
      },
      {
        path: '/CardStatisticsDetail',
        name: '兑换礼券统计详情',
        meta: {
          navType: 8,
          belong: '券卡统计',
        },
        component: () => import('@/views/StatisticsFolder/CardStatistics/CardStatisticsDetail.vue'),
      },
      {
        path: '/AllOrderStatisticsList',
        name: '全部订单统计',
        meta: {
          navType: 8,
          belong: '订单统计',
          keepAliv: true,
        },
        component: () => import('@/views/StatisticsFolder/OrderStatistics/AllOrderStatisticsList.vue'),
      },
      {
        path: '/OrderStatisticsDetail',
        name: '订单统计详情',
        meta: {
          navType: 8,
          belong: '订单统计',
        },
        component: () => import('@/views/StatisticsFolder/OrderStatistics/OrderStatisticsDetail.vue'),
      },
      {
        path: '/AllExpressStatisticsList',
        name: '全部快递统计',
        meta: {
          navType: 8,
          belong: '发货统计',
          keepAliv: true,
        },
        component: () => import('@/views/StatisticsFolder/ExpressStatistics/AllExpressStatisticsList.vue'),
      },
      {
        path: '/ExpressStatisticsDetail',
        name: '快递统计详情',
        meta: {
          navType: 8,
          belong: '发货统计',
        },
        component: () => import('@/views/StatisticsFolder/ExpressStatistics/ExpressStatisticsDetail.vue'),
      },
      {
        path: '/ExpressDeliverStatisticsList',
        name: '快递发货统计',
        meta: {
          navType: 8,
          belong: '发货统计',
          keepAliv: true,
        },
        component: () => import('@/views/StatisticsFolder/ExpressStatistics/ExpressDeliverStatisticsList.vue'),
      },
      {
        path: '/FlowDeliverStatisticsList',
        name: '门店发货统计',
        meta: {
          navType: 8,
          belong: '发货统计',
          keepAliv: true,
        },
        component: () => import('@/views/StatisticsFolder/ExpressStatistics/FlowDeliverStatisticsList.vue'),
      },
      {
        path: '/ExpressDeliverStatisticsDetail',
        name: '快递发货统计详情',
        meta: {
          navType: 8,
          belong: '发货统计',
        },
        component: () => import('@/views/StatisticsFolder/ExpressStatistics/ExpressDeliverStatisticsDetail.vue'),
      },
      {
        path: '/FlowDeliverStatisticsDetail',
        name: '自提发货统计详情',
        meta: {
          navType: 8,
          belong: '发货统计',
        },
        component: () => import('@/views/StatisticsFolder/ExpressStatistics/FlowDeliverStatisticsDetail.vue'),
      },{
        path: '/CollectStatisticsList',
        name: '收款统计',
        meta: {
          navType: 8,
          belong: '对账统计',
          keepAliv: true,
        },
        component: () => import('@/views/StatisticsFolder/DealerStatistics/CollectStatisticsList.vue'),
      },,{
        path: '/PaymentStatisticsList',
        name: '付款统计',
        meta: {
          navType: 8,
          belong: '对账统计',
          keepAliv: true,
        },
        component: () => import('@/views/StatisticsFolder/DealerStatistics/PaymentStatisticsList.vue'),
      },{
        path: '/PaymentCardTotal',
        name: '经销商收/付款报表卡券总数',
        meta: {
          navType: 8,
          belong: '对账统计',
          keepAliv: true,
        },
        component: () => import('@/views/StatisticsFolder/DealerStatistics/PaymentCardTotal.vue'),
      },{
        path: '/CardTotalStatisticsDetail',
        name: '券卡总数统计',
        meta: {
          navType: 8,
          belong: '对账统计',
        },
        component: () => import('@/views/StatisticsFolder/DealerStatistics/CardStatisticsDetail.vue'),
      },{
        path: '/DealerReconciliation',
        name: '净额结算对账统计',
        meta: {
          navType: 8,
          belong: '净额结算对账统计',
        },
        component: () => import('@/views/StatisticsFolder/ReconciliationStatistics/DealerReconciliation.vue'),
      },{
        path: '/HBGDealerReconciliation',
        name: '结算对账统计',
        meta: {
          navType: 8,
          belong: '结算对账统计',
        },
        component: () => import('@/views/StatisticsFolder/HBGReconciliationStatistics/DealerReconciliation.vue'),
      },
      {
        path: '/PlatformBulletin',
        name: '平台公告',
        meta: {
          navType: 9,
          belong: '平台公告'
        },
        component: () => import('@/views/MessageCenter/PlatformBulletin.vue')
      },
      {
        path: '/NbuPlatformBulletin',
        name: '门店内部公告',
        meta: {
            navType: 9,
            belong: '门店内部公告',
            keepAliv: false,
        },
        component: () =>
            import ('@/views/MessageCenter/NbuPlatformBulletin.vue')
      },
      ]
    },
    // 发票管理
    {
      path: '/InvoiceManage',
      name: '开票管理',
      meta: {
        navType: 10,
        belong: '开票管理',
        keepAliv: true,
      },
      component: () => import('@/views/InvoiceManage/InvoiceManage.vue'),
    },{
      path: '/InvoiceDetail/:recordcode/:operateType',
      name: '开票详情',
      meta: {
        navType: 10,
        belong: '开票管理',
      },
      component: () => import('@/views/InvoiceManage/InvoiceDetail.vue'),
    },{
      path: '/SellerList',
      name: '销售方管理',
      meta: {
        navType: 10,
        belong: '销售方管理',
      },
      component: () => import('@/views/InvoiceManage/SellerList.vue'),
    },{
      path: '/ProcureExamine',
      name: '开票商品采购审核',
      meta: {
        navType: 10,
        belong: '开票商品采购审核',
        keepAliv: true,
      },
      component: () => import('@/views/InvoiceManage/ProcureExamine.vue'),
    },{
      path: '/ProcureExamineDetail/:purcode',
      name: '开票商品采购审核详情',
      meta: {
        navType: 10,
        belong: '开票商品采购审核',
      },
      component: () => import('@/views/InvoiceManage/ProcureExamineDetail.vue'),
    },{
      path: '/PurchasingList',
      name: '开票商品采购清单',
      meta: {
        navType: 10,
        belong: '开票采购管理',
        keepAliv: true,
      },
      component: () => import('@/views/InvoiceManage/PurchasingList.vue'),
    },{
      path: '/PurchaseAdd',
      name: '开票商品采购录入',
      meta: {
        navType: 10,
        belong: '开票采购管理',
      },
      component: () => import('@/views/InvoiceManage/PurchaseAdd.vue'),
    },{
      path: '/PurchaseDetail/:purcode',
      name: '开票商品采购详情',
      meta: {
        navType: 10,
        belong: '开票采购管理',
      },
      component: () => import('@/views/InvoiceManage/PurchaseDetail.vue'),
    },{
      path: '/PurchaseCheck/:purcode',
      name: '开票商品采购审核',
      meta: {
        navType: 10,
        belong: '开票商品采购审核',
      },
      component: () => import('@/views/InvoiceManage/PurchaseCheck.vue'),
    },
    {
      path: '/InvoiceGoodsManage',
      name: '开票商品',
      meta: {
        navType: 10,
        belong: '开票商品管理',
      },
      component: () => import('@/views/InvoiceManage/InvoiceGoodsManage.vue'),
    },
    {
      path: '/OrderBangKa',
      name: '销售绑卡管理',
      component: () => import('@/views/OrderBangKa/Order_BangKa.vue'),
      children: [
        //绑卡管理
        {
          path: '/CardSearchIndexbk',
          name: '券卡查询bk',
          meta: {
            navType: 11,
            belong: '券卡查询bk'
          },
          component: () => import('@/views/CardsFolder/CardsSearch/SearchIndex.vue')
        },
        {
          path: '/HistoricalShipmentRecordsbk',
          name: '销售绑卡',
          meta: {
            navType: 11,
            belong: '销售绑卡',
          },
          component: () => import('@/views/OrderFolder/StoreSale/HistoricalShipmentRecordsbk.vue'),
        }
      ]
    },
    //库存管理
    {
      path: '/ShopInventoryManage',
      name: '单品库存',
      meta: {
        navType: 12,
        belong: '单品库存',
      },
      component: () => import('@/views/InventoryMange/ShopInventoryManage.vue'),
    },{
      path: '/InventoryTransferRecord/:singlecode',
      name: '单品库存调拨记录',
      meta: {
        navType: 12,
        belong: '单品库存调拨记录',
      },
      component: () => import('@/views/InventoryMange/InventoryTransferRecord.vue'),
    },{
      path: '/StoreCardInventory',
      name: '券卡库存',
      meta: {
        navType: 12,
        belong: '券卡库存',
      },
      component: () => import('@/views/InventoryMange/StoreCardInventory.vue'),
    },

    ]
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js